import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
import {ToTrinhFileService} from '../../../../service/totrinh/service-totrinhfile';
import {DatePipe} from '@angular/common';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {CommandUtil} from '../../../../global/commandutil';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {YeuCauFile} from '../../../../models/yeucau/yeucaufile';;
import {YeuCauFileNXLService} from '../../../../service/yeucau/service-yeucaufilenxl';
import {YeuCauComment} from '../../../../models/yeucau/yeucaucomment';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauCommentService} from '../../../../service/yeucau/service-yeucaucomment';
import {YeuCau} from '../../../../models/yeucau/yeucau';
import {YeuCauXuLy} from '../../../../models/yeucau/yeucauxuly';
import {YeuCauXuLyService} from '../../../../service/yeucau/service-yeucauxuly';
import {YeuCauFileService} from '../../../../service/yeucau/service-yeucaufile';

@Component({
  templateUrl: './chuyentrinhycn.component.html'

})
export class CTYeuCauNhanComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public id: number=0;
  public yeuCauId: number =0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public staffSelectList: Object[];
  public selectedList: Object[];
  public isStatus: boolean = false;
  public dateHoanThanh: Date;
  public yeuCauXuLyItem: YeuCauXuLy = new YeuCauXuLy();
  public  onClose: Subject<boolean>;
  public yeuCauFiles: YeuCauFile[]=[];
  public isOpen: boolean = false;
  public yeuCauCommentList: YeuCauComment[] = [];
  constructor(  public toTrinhService: ToTrinhService,
                public formBuilder: FormBuilder,
                public toastr: ToastrService,
                public bsModalService: BsModalService,
                public datepipe: DatePipe,
                public _bsModalRef: BsModalRef,
                public toTrinhXuLyService: ToTrinhXuLyService,
                public commandUtils: CommandUtil,
                public toTrinhFileService: ToTrinhFileService,
                public yeuCauFileService: YeuCauFileService,
                public yeuCauService: YeuCauService,
                public yeuCauXuLyService: YeuCauXuLyService,
                public yeuCauCommentService: YeuCauCommentService
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  public edit(id: number) {
    this.yeuCauId= id;
    this.yeuCauXuLyService.getById(id).subscribe( data => {this.yeuCauXuLyItem = data;
      this.yeuCauCommentService.findAllByYeuCau(data.maYeuCau). subscribe( ym => this.yeuCauCommentList = ym);
      this.yeuCauFileService.findAllByYeuCauId(data.maYeuCau).subscribe(ycf => this.yeuCauFiles= ycf);
    });
  }
  public showStaff(id: number)
  {
    this.toTrinhXuLyService.findByMaYeuCau(id).subscribe(
      x => {
        for(let i=0; i< x.length; i++)
        {
          this.staffSelectList= [...this.staffSelectList, {id: x[i].maNguoiXuLy, fullName: x[i].nguoiXuLy.fullName}];
          this.selectedList= [...this.selectedList, x[i].maNguoiXuLy];
        }

      });
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      chuDe: new FormControl(),
      thoiGianHoanThanh: new FormControl(),
      noiDung: new FormControl(),
      trangThai: new FormControl(0),
      maNguoiChuTri: new FormControl(0)

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      chuDe: ['' , Validators.compose([validateEmpty]) ],
      thoiGianHoanThanh: ['', Validators.compose([validateEmpty])],
      noiDung: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator],
      maNguoiChuTri: ['', Validators.nullValidator]
    });
    this.uploadUrl= this.toTrinhFileService.urlUpload;
    this.deleteUrl= this.toTrinhFileService.urlDelete;
    this.staffSelectList = [];
    this.selectedList = [];

  }
  get f() { return this.frmGroup.controls; }

  public createItem ()
  {
    this.frmGroup.value.thoiGianHoanThanh = this.datepipe.transform(this.dateHoanThanh, 'dd/MM/yyyy');;
    this.frmGroup.value.trangThai= this.isStatus == true ? 1 : 0;
    let arrStaff: string = this.selectedList.join();
    this.frmGroup.value.maNguoiChuTri = Sessioncommand.staffId;
    this.toTrinhService.add(arrStaff, this.frmGroup.value).subscribe(
      { next: (data) => {
          this.uploadFileComponent.id = data.id;
          this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
          this.toastr.success(this.isStatus == false? language.add_success_record: language.send_success_record, language.message);
          let recordFile: number= 0;
          this.yeuCauService.chuyenTrinh(data.id, this.yeuCauId, Sessioncommand.staffId ).subscribe(dt => recordFile = dt);
          Sessioncommand.notification = true;
          Sessioncommand.giaiQuyetSuVuStatus = 0;
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  public showGroup()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for (let i = 0; i < result.length; i++) {

          if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
            this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
            this.selectedList= [...this.selectedList, result[i].id];
          }
        }
      }
    });
  }
  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    this.createItem();
    this.onClose.next(true);
    if( this.isStatus == true)
      this._bsModalRef.hide();
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

